import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Observable } from 'rxjs';

import { AbstractComponent } from '../../definition/abstract/abstract.component';
import { MessageDialogComponent } from './message-dialog.component';
import { MessageDialogInteractionModel } from './model/message-dialog-interaction.model';

@Injectable({
    providedIn: 'root'
})
export class MessageDialogService extends AbstractComponent {
    constructor(public dialog: MatDialog) {
        super();
    }

    public openSuccessDialog(message: string, boldMessage = 'Sucesso', link?: string,  linkMessage?: string, icon = 'fa-regular fa-circle-check'): Observable<MessageDialogInteractionModel | undefined> {
        const ref = this.dialog.open(MessageDialogComponent, {
            data: {
                boldMessage,
                message,
                icon,
                link,
                linkMessage,
                isError: false
            }
        })
        return ref.afterClosed();
    }
    public openConfirmation(message: string, boldMessage = 'Você tem certeza?'): Observable<MessageDialogInteractionModel> {
        const ref = this.dialog.open(MessageDialogComponent, {
            data: {
                boldMessage,
                message,
                isError: false,
                isConfirmation: true,
                icon: 'uii-warning'
            }
        })
        return ref.afterClosed();
    }
    public openErrorDialog(message: string, boldMessage = 'Falha', subMessage?: string, refresh = false, link?: string, icon = 'uii-alert'): Observable<MessageDialogInteractionModel | undefined> {
        const ref = this.dialog.open(MessageDialogComponent, {
            data: {
                message,
                boldMessage,
                icon,
                link,
                subMessage,
                isError: true,
                canRefresh: refresh
            }
        })
        return ref.afterClosed();
    }
}
